import React, { useState } from 'react';
import { BaseConfig } from '../BaseConfig';
import { UIProperties } from '../UIProperties';

import './SplashScreenUI.css'

const SplashScreenUI = (props: UIProperties<SplashScreenUIConfig>) => {
	return (
		<div className="ui-top-most-container splash-fadein">
			<img src="./assets/images/general/backgrounds/splash-screen.jpeg" />
			<img style={{
				position: 'absolute',
				top: '790px',
				left: '690px',
				width: '160px',
			}} src="./assets/images/general/icons/spinner.png" />
			<p style={{
				position: 'absolute',
				top: '825px',
				left: '860px',
				color: 'rgb(130,136,248)',
				textShadow: '2px 2px rgba(0,0,0,.7)',
				fontSize: '70px',
				margin: '0',
				fontWeight: 400
			}} className="regular-description-font">Loading...</p>
		</div>
	);

};

export interface SplashScreenUIConfig extends BaseConfig {
}

export default SplashScreenUI;